module.exports = __webpack_public_path__ + "img/badicause.953d6503.jpg";